var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emd-text _size_small" },
    _vm._l(_vm.tableData, function (item) {
      return _c("data-display-field", {
        key: item.fieldName,
        attrs: { fieldData: item },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }